import * as Icon from "shared/icons";

export default Icon;
